export default class ArrayUtils
{
    static modifyIndex (arr, oldIndex, newIndex)
    {
        while (oldIndex < 0)
        {
            oldIndex += arr.length;
        }
        while (newIndex < 0)
        {
            newIndex += arr.length;
        }

        if (newIndex >= arr.length)
        {
            let k = newIndex - arr.length + 1;
            while (k--)
            {
                arr.push(undefined);
            }
        }

        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);

        return arr
    }

    static arrayToDictionary (array)
    {
        if (!Array.isArray(array)) return array 

        return array.reduce((result, item, index, array) =>
        {
            if (!item.id)
            {
                console.error('Item', item, 'of array', array, 'has no id, cannot convert to dictionary')

                return undefined
            }

            result[item.id] = item

            return result
        })
    }

    static mergeArrays (a, b, comparaison)
    {
        if (a == undefined) a = []
        if (b == undefined) b = []
        if (!Array.isArray(a)) a = [a]
        if (!Array.isArray(b)) b = [b]

        // duplicate
        const base = a.slice(0)

        for (let element of b)
        {
            let ElementWithSameId = base.find(e => comparaison(e, element))
            if (ElementWithSameId)
            {
                element = Object.assign({}, ElementWithSameId, element)
                base.splice(base.indexOf(ElementWithSameId), 1)
            }

            base.push(element)
        }

        return base
    }

    static removeByValue (arr, value)
    {
        const index = arr.indexOf(value)
        if (index == -1) return

        return arr.splice(index, 1)
    }

    static pushIfDontExist (arr, value)
    {
        if (!arr.includes(value)) arr.push(value)
    }

    static areEqualSets (s1, s2)
    {
        return (s1.length === s2.length) && (s1.every(val => s2.includes(val)))
    }

    static flatten (arrays)
    {
        return [].concat.apply([], arrays)
    }

    /**
     * @template T
     * @param {T} type
     * @returns {T[]}
     */
    static empty (type)
    {
        return []
    }
     
    /**
     * @template T
     * @param {T[]} arr
     * @returns T
     */
    static getLast (arr)
    {
        if (this.isEmpty(arr)) return null
        return arr[arr.length - 1]
    }
     
    /**
     * @template T
     * @param {T[]} arr
     * @param {T} value
     * @returns {T}
     */
    static setLast (arr, value)
    {
        if (this.isEmpty(arr)) return null
        return arr[arr.length - 1] = value
    }
     
    /**
     *
     * @param  {...any[]} args
     * @returns {any[]}
     */
    static firstNotEmpty (...args)
    {
        for (let arg of args)
        {
            if (arg && arg.length) return arg
        }
        return []
    }
     
    static isEmpty (arr)
    {
        return (!Array.isArray(arr) || arr.length == 0)
    }
     
    /**
     * @template T
     * @param {Array<T>} arr
     * @returns {Array<T>}
     */
    static clone (arr)
    {
        return arr.slice(0)
    }
     
    /**
     * @template T
     * @param {Array<T>} a
     * @param {Array<T>} b
     * @param {Object} args
     * @param {boolean} [args.ignoreOrder]
     * @returns {boolean}
     */
    static areEqual (a, b, { ignoreOrder = false } = {})
    {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;
     
        if (ignoreOrder)
        {
            a = this.clone(a).sort()
            b = this.clone(b).sort()
        }
     
        for (var i = 0; i < a.length; ++i) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
     
    /**
     * @template T
     * @param {Array<T>} arr
     * @returns {Array<T>}
     */
    static removeDuplicates (arr)
    {
        return Array.from(new Set(arr))
    }
     
    /**
     * @template T
     * @param {Array<T>} arr
     * @param {...T} toRemove
     * @returns {Array<T>}
     */
    static removeAll (arr, ...toRemove)
    {
        return arr.filter(item => !toRemove.includes(item))
    }
}


// WEBPACK FOOTER //
// ./src/utils/arrayUtils.js